import { render, staticRenderFns } from "./ContractorFailedPayments.vue?vue&type=template&id=229ccdb2&scoped=true&"
import script from "./ContractorFailedPayments.vue?vue&type=script&lang=js&"
export * from "./ContractorFailedPayments.vue?vue&type=script&lang=js&"
import style0 from "./ContractorFailedPayments.vue?vue&type=style&index=0&id=229ccdb2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229ccdb2",
  null
  
)

export default component.exports